var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "properties-field", attrs: { id: _vm.id } },
    [
      _c("div", { staticClass: "wrap-properties" }, [
        _c("div", { staticClass: "properties-field-title" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "close-properties",
              on: { click: _vm.closeConfiguration }
            },
            [_vm._v("\n        ×\n      ")]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "properties-field-content properties-field-content-config"
          },
          [
            _c(
              "div",
              { staticClass: "section-field input-field" },
              [
                _c(
                  "b-form",
                  {
                    class: { "error-input": _vm.$v.dataSetup.sheet_name.$error }
                  },
                  [
                    _c("label", [_vm._v(" Sheet Name ")]),
                    _vm._v(" "),
                    _c("j-input", {
                      attrs: { placeholder: "Enter sheet name" },
                      model: {
                        value: _vm.dataSetup.sheet_name,
                        callback: function($$v) {
                          _vm.$set(_vm.dataSetup, "sheet_name", $$v)
                        },
                        expression: "dataSetup.sheet_name"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.firstSheet
                  ? _c(
                      "b-form",
                      {
                        class: {
                          "error-input": _vm.$v.dataSetup.column_source.$error
                        }
                      },
                      [
                        _c("label", [_vm._v(" Column Source ")]),
                        _vm._v(" "),
                        _c("j-single-select", {
                          attrs: {
                            options: _vm.variableCustomColumns,
                            placeholder: "Select Column Source",
                            label: "label"
                          },
                          model: {
                            value: _vm.dataSetup.column_source,
                            callback: function($$v) {
                              _vm.$set(_vm.dataSetup, "column_source", $$v)
                            },
                            expression: "dataSetup.column_source"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "section-field input-field" }, [
              _c(
                "div",
                {
                  staticClass: "configuration-section",
                  class: { "error-input": _vm.$v.dataSetup.main_columns.$error }
                },
                [
                  _c(
                    "h4",
                    { staticClass: "configuration-section-title mb-2" },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.firstSheet ? "Column" : "Main Column") +
                          "\n          "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "draggable",
                    {
                      staticClass: "d-flex flex-wrap",
                      attrs: {
                        options: {
                          animation: 300,
                          handle: ".icon-drag"
                        }
                      },
                      model: {
                        value: _vm.dataSetup.main_columns,
                        callback: function($$v) {
                          _vm.$set(_vm.dataSetup, "main_columns", $$v)
                        },
                        expression: "dataSetup.main_columns"
                      }
                    },
                    _vm._l(_vm.dataSetup.main_columns, function(data, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "field-list py-2",
                          class: { selected: index === _vm.selectedIndexColumn }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center" },
                            [
                              _c("img", {
                                staticClass: "icon-drag",
                                attrs: {
                                  src: require("@/assets/new-form-ui/dragged.svg")
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "field-preview" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "input-preview column-preview"
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("@/assets/icon/column-type/" +
                                          _vm.setIconType(data.type) +
                                          ".svg"),
                                        alt: data.name + "-block"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "separator" }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "column-name" }, [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(data.name) +
                                          "\n                    "
                                      )
                                    ])
                                  ]
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "edit-or-delete" }, [
                            _c("div", { staticClass: "button" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "edit",
                                  on: {
                                    click: function($event) {
                                      _vm.openConfigColumn(data, index, false)
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-pencil-square-o"
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "delete",
                                  on: {
                                    click: function($event) {
                                      _vm.deleteColumn(index, false)
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fa fa-trash" })]
                              )
                            ])
                          ])
                        ]
                      )
                    })
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "btn-add-config",
                      on: {
                        click: function($event) {
                          _vm.openConfigColumn(null, null, false)
                        }
                      }
                    },
                    [_vm._v("\n            + Add Column\n          ")]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            !_vm.firstSheet
              ? _c("div", { staticClass: "section-field input-field" }, [
                  _c(
                    "div",
                    {
                      staticClass: "configuration-section",
                      class: {
                        "error-input":
                          _vm.$v.dataSetup.custom_class_columns.$error
                      }
                    },
                    [
                      _c(
                        "h4",
                        { staticClass: "configuration-section-title mb-2" },
                        [
                          _vm._v(
                            "\n            Custom Class Column\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "draggable",
                        {
                          staticClass: "d-flex flex-wrap",
                          attrs: {
                            options: {
                              animation: 300,
                              handle: ".icon-drag"
                            }
                          },
                          model: {
                            value: _vm.dataSetup.custom_class_columns,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.dataSetup,
                                "custom_class_columns",
                                $$v
                              )
                            },
                            expression: "dataSetup.custom_class_columns"
                          }
                        },
                        _vm._l(_vm.dataSetup.custom_class_columns, function(
                          data,
                          index
                        ) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "field-list py-2",
                              class: {
                                selected: index === _vm.selectedIndexColumn
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c("img", {
                                    staticClass: "icon-drag",
                                    attrs: {
                                      src: require("@/assets/new-form-ui/dragged.svg")
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "field-preview" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "input-preview column-preview"
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: require("@/assets/icon/column-type/" +
                                              _vm.setIconType(data.type) +
                                              ".svg"),
                                            alt: data.name + "-block"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "separator" }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "column-name" },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(data.name) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "edit-or-delete" }, [
                                _c("div", { staticClass: "button" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "edit",
                                      on: {
                                        click: function($event) {
                                          _vm.openConfigColumn(
                                            data,
                                            index,
                                            true
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-pencil-square-o"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "delete",
                                      on: {
                                        click: function($event) {
                                          _vm.deleteColumn(index, true)
                                        }
                                      }
                                    },
                                    [_c("i", { staticClass: "fa fa-trash" })]
                                  )
                                ])
                              ])
                            ]
                          )
                        })
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "btn-add-config",
                          on: {
                            click: function($event) {
                              _vm.openConfigColumn(null, null, true)
                            }
                          }
                        },
                        [_vm._v("\n            + Add Column\n          ")]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "properties-field-button",
            class: { "justify-content-end": !_vm.fieldDetail }
          },
          [
            _vm.fieldDetail
              ? _c(
                  "button",
                  {
                    staticClass: "button-border",
                    on: { click: _vm.deleteSheet }
                  },
                  [
                    _c("i", { staticClass: "fa fa-trash" }),
                    _vm._v(" Delete\n      ")
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex align-items-center" }, [
              _c(
                "button",
                {
                  staticClass: "button-border mr-2",
                  on: { click: _vm.closeConfiguration }
                },
                [_vm._v("\n          Close\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                { staticClass: "button-blue", on: { click: _vm.submitForm } },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.fieldDetail ? "Update" : "Add") +
                      "\n        "
                  )
                ]
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _vm.isOpenConfigColumn
        ? _c("column-configuration", {
            attrs: {
              id: _vm.idConfigColumn,
              "field-detail": _vm.selectedColumn,
              "select-variable": _vm.listVariable,
              "use-additional-format": true,
              "use-filter": _vm.firstSheet ? true : false,
              "is-group": true,
              "is-dataset-source": _vm.isDatasetSource,
              type: "export"
            },
            on: {
              "delete-configuration": _vm.deleteColumn,
              "close-configuration": function($event) {
                _vm.toggleConfigurationColumn(false)
              },
              "submit-configuration": _vm.submitColumn
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "title" }, [
      _vm._v("\n        Properties\n        "),
      _c("div", { staticClass: "title-badge" }, [_vm._v("Sheet")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bbf5179a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bbf5179a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/partials/configuration/SheetConfiguration.vue
// module id = null
// module chunks = 